import { Stack, Typography } from '@mui/material'

import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

type TicketPurchaseStatusProps = {
  purchasedNumber?: number
  issuedNumber?: number
}
export const TicketPurchaseStatus: Organism<TicketPurchaseStatusProps> = ({
  purchasedNumber,
  issuedNumber,
}) => {
  const { t } = useTranslation('consoleEventDetail')
  return (
    <Stack
      flex={1}
      spacing={2}
      sx={{
        p: 4,
        bgcolor: 'grey.50',
        borderRadius: '6px',
      }}
    >
      <Typography variant="subtitle1" align="left" width="100%">
        {t('purchaseStatus', '購入状況')}
      </Typography>
      <Stack spacing={1} alignItems="center">
        <Stack direction="row" alignItems="center">
          <Typography variant="h3" color="secondary.main">
            {purchasedNumber || '-'}
          </Typography>
          <Typography variant="h6">/</Typography>
          <Typography variant="subtitle2" pt={1}>
            {issuedNumber || '-'}
          </Typography>
        </Stack>
        <Typography variant="overline" color="text.secondary">
          {t('purchaseStatusNote', '購入数/在庫数')}
        </Typography>
      </Stack>
    </Stack>
  )
}
